import {
  HeaderContext,
  HeaderContextValues
} from 'components/Header/HeaderProvider'
import React, { useMemo } from 'react'
import useCart from 'queries/useCart'
import useUser from 'queries/useUser'

import logoUrl from 'images/bft-logo-black-truck-only-small.inline.png'

type Props = {
  staticPage?: boolean
  children: React.ReactNode
}

export default function NextHeaderProvider({ children, staticPage }: Props) {
  let cart
  let user
  if (staticPage && typeof window === 'undefined') {
    cart = null
    user = null
  } else {
    // eslint-disable-next-line react-hooks/rules-of-hooks, prefer-destructuring
    cart = useCart().cart
    // eslint-disable-next-line react-hooks/rules-of-hooks, prefer-destructuring
    user = useUser().user
  }

  const config: HeaderContextValues = useMemo(
    () => ({
      truckDashboardHeaderUrl: (url) =>
        `${process.env.NEXT_PUBLIC_TRUCK_DASHBOARD_URL}${url}`,
      logoUrl,
      cartItems: cart?.items?.length || 0,
      user
    }),
    [cart, user]
  )

  return (
    <HeaderContext.Provider value={config}>{children}</HeaderContext.Provider>
  )
}
